import React, { FC } from 'react';
import FlipCardStyled from './FlipCardStyled';

interface Props {
  children: JSX.Element;
  flipped: boolean;
  isFlipCard: boolean;
}

const FlipCard: FC<Props> = ({
  children,
  flipped,
  isFlipCard
}) => {

  if (!isFlipCard) {
    return (children);
  }

  return (
    <>
      <FlipCardStyled flipped={flipped}>
        <div className="flip-card__body">
          { children }
        </div>
      </FlipCardStyled>
    </>
  );
};

FlipCard.displayName = 'FlipCard';

export default FlipCard;
